<template>
  <div class="goodsCountTable">
    <!-- 类型/三方名称/锐锢编码/三方编码/商品名称/单位/供货成交价/数量/供货金额 -->
    <el-table :data="data" :summary-method="getSummaries" show-summary border style="width: 100%" max-height="500">
      <el-table-column type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="order_type_text" label="类型">
      </el-table-column>
      <el-table-column prop="shop_name" label="三方名称">
      </el-table-column>
      <el-table-column prop="sku_code" label="锐锢编码">
      </el-table-column>
      <!-- <el-table-column prop="self_code" label="三方编码">
      </el-table-column> -->
      <el-table-column prop="sku_name" label="商品名称" width="300">
      </el-table-column>
      <el-table-column prop="unit" label="单位">
      </el-table-column>
      <el-table-column prop="order_price" label="供货成交价">
      </el-table-column>
      <el-table-column prop="sum_order_quantity" label="数量">
        <template slot-scope="scope">
          <span>{{scope.row.sum_order_quantity | fixedNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sum_order_amount" label="供货金额">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
const isType = type => target => `[object ${type}]` === Object.prototype.toString.call(target)
const isNumber = isType('Number')
export default {
  props: ['data'],
  data () {
    return {
    }
  },
  filters: {
    fixedNumber (val) {
      let value = Number(val)
      return isNaN(isNumber(value)) ? '' : parseFloat(value)
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (index === 0) {
          sums[index] = '合计'
        } else if (index === 7) {
          // sums[index] = this.data.total_amount
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0))
          } else {
            sums[index] = ''
          }
        } else if (index === 8) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
          // sums[index] = this.data.total_price
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/GoodsCountTable.vue